import { useState } from "react";

const products = [
  {
    id: 1,
    name: "Respect Club Vest",
    price: "$350",
    category: "Vests",
    sizes: ["S", "M", "L", "XL", "2XL"],
    image: "https://public.readdy.ai/ai/img_res/942c6c4d-18f7-412f-b84e-54a47641e4aa.png",
  },
  {
    id: 2,
    name: "Respect Motorcycle club Steel Chain",
    price: "$125",
    category: "jewelry",
    sizes: ["S", "M", "L", "XL", "2XL", "3XL"],
    image: "https://static.readdy.ai/image/0b053ca972f96e6a72462b3430aa5d72/8f6ca18a8e942aeffe939bc149ad9d28.jpeg",
  },
  {
    id: 3,
    name: "Riders Hoodie",
    price: "$85",
    category: "Hoodies",
    sizes: ["S", "M", "L", "XL", "3x"],
    image: "https://static.readdy.ai/image/0b053ca972f96e6a72462b3430aa5d72/4abcffd87d3e65dd7dda0a7effea2cbd.jpeg",
  },
  {
    id: 4,
    name: "Club Snapback Cap",
    price: "$35",
    category: "Hats",
    sizes: ["One Size"],
    image: "https://static.readdy.ai/image/0b053ca972f96e6a72462b3430aa5d72/2d68da6922777a5ee17c71aff196906e.jpeg",
  },
  {
    id: 5,
    name: "IBMC Leather Jacket",
    price: "",
    category: "Jackets",
    sizes: ["S", "M", "L"],
    image: "https://public.readdy.ai/ai/img_res/66891bfc695e3b11b195d35ae8c01756.jpg",
  },
  {
    id: 6,
    name: "Brotherhood Bandana",
    price: "$15",
    category: "Accessories",
    sizes: ["One Size"],
    image: "https://readdy.ai/api/search-image?query=black%20red%20motorcycle%20bandana%20skull%20design%20flat%20lay%20product%20photography%20dark%20background%20clean%20accessories%20biker%20style&width=500&height=500&seq=app006&orientation=squarish",
  },
];

export default function ApparelSection() {
  const [selectedSizes, setSelectedSizes] = useState<Record<number, string>>({});
  const [added, setAdded] = useState<number[]>([]);

  const handleAddToCart = (id: number) => {
    setAdded((prev) => [...prev, id]);
    setTimeout(() => setAdded((prev) => prev.filter((i) => i !== id)), 2000);
  };

  return (
    <section id="apparel" className="w-full bg-[#111111] py-24 px-6 lg:px-20" data-product-shop>
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-4">
          <div>
            <p className="text-red-500 uppercase tracking-[0.3em] text-xs font-bold mb-3">Represent</p>
            <h2 className="text-4xl md:text-5xl font-black text-white uppercase" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>
              Club Apparel
            </h2>
          </div>
          <p className="text-gray-500 text-sm max-w-xs">Official IBMC gear. Wear your colors with pride.</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {products.map((product) => (
            <div key={product.id} className="bg-[#1a1a1a] border border-[#2a2a2a] group overflow-hidden">
              {product.id !== 5 && product.id !== 6 && (
                <div className="relative w-full h-64 overflow-hidden bg-[#0d0d0d]">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <span className="absolute top-4 left-4 bg-black/70 text-gray-400 text-xs uppercase tracking-wider px-2 py-1">
                    {product.category}
                  </span>
                </div>
              )}
              <div className="p-5">
                {product.id !== 5 && product.id !== 6 && (
                  <div className="flex justify-between items-start mb-3">
                    <h3 className="text-white font-black text-lg uppercase" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>{product.name}</h3>
                    {product.id !== 6 && (
                      <span className="text-red-500 font-black text-xl" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>{product.price}</span>
                    )}
                  </div>
                )}

                {product.sizes.length > 1 && (
                  <div className="mb-4">
                    <p className="text-gray-600 text-xs uppercase tracking-wider mb-2">Size</p>
                    <div className="flex flex-wrap gap-2">
                      {product.sizes.map((size) => (
                        <button
                          key={size}
                          onClick={() => setSelectedSizes((prev) => ({ ...prev, [product.id]: size }))}
                          className={`w-9 h-9 text-xs font-bold uppercase border transition-all cursor-pointer ${
                            selectedSizes[product.id] === size
                              ? "border-red-600 bg-red-900/30 text-white"
                              : "border-[#333] text-gray-500 hover:border-gray-500"
                          }`}
                        >
                          {size}
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                {product.id !== 5 && product.id !== 6 && (
                  <button
                    onClick={() => handleAddToCart(product.id)}
                    className={`w-full py-3 uppercase font-bold tracking-widest text-xs transition-all duration-300 cursor-pointer whitespace-nowrap ${
                      added.includes(product.id)
                        ? "bg-green-800 text-white"
                        : "bg-red-700 hover:bg-red-600 text-white"
                    }`}
                  >
                    {added.includes(product.id) ? (
                      <span className="flex items-center justify-center gap-2">
                        <i className="ri-check-line"></i> Added to Cart
                      </span>
                    ) : (
                      "Add to Cart"
                    )}
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
